'use client'

import { Loader } from '@paysense-india-services/elevate-web'

import styles from './index.module.scss'

const PageLoader = ({ isLoading = false, size = 'large' }) => (
  <>
    {isLoading ? (
      <div className={`${styles.wrap} ew-d-flex ew-justify-content-center ew-align-items-center `}>
        <Loader size={size} />
      </div>
    ) : null}
  </>
)

export default PageLoader
